/** @jsxImportSource @emotion/react */
import React from 'react'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import renderIf from '@signal/utils/renderIf'
import { AnyReactComponentType } from '@signal/utils/types'
import HeaderNew from '../HeaderNew'
import { Wrapper } from './styles'
import { CommonPagePropsType } from './types'
import SkeletonNew from '../LeftMenuNew/Skeleton'

const ActiveHeader = HeaderNew as AnyReactComponentType

export const CommonPageSkeleton: React.FC<CommonPagePropsType> = ({
  appMinWidth,
  children,
  hideChrome,
  hideLogo,
  hideMenu,
  title
}) => {
  return (
    <Wrapper
      adjustPageContainerForMenu={!(hideMenu || hideChrome)}
      constrainWidth={false}
      disableGutter
      left={hideChrome || hideMenu ? undefined : SkeletonNew}
    >
      {renderIf(!hideChrome, () => (
        <ActiveHeader
          appMinWidth={appMinWidth}
          hideLogo={hideLogo}
          isSkeleton
          title={title}
        />
      ))}
      {children}
    </Wrapper>
  )
}

export default withCommonSnapshotsOnly(CommonPageSkeleton)
